// Service layer for Git-related API calls
import { fetchBaseUrl } from "core/utils/common";
const apiURL = `${fetchBaseUrl({ port: 8000 })}/mcg/api`;

async function apiGet<T>(url: string): Promise<T> {
  const res = await fetch(url, {
    credentials: "include",
  });

  if (!res.ok) {
    throw new Error(`API failed: ${res.status} ${res.statusText}`);
  }

  return res.json();
}

async function apiPost<T>(url: string, body?: any): Promise<T> {
  const res = await fetch(url, {
    method: "POST",
    credentials: "include",
    body: JSON.stringify(body),
    headers: {
      "Content-Type": "application/json",
    },
  });

  if (!res.ok) {
    throw new Error(`API failed: ${res.status} ${res.statusText}`);
  }

  return res.json();
}

export type Repo = { id: number; name: string; http_url_to_repo: string };
export type Branch = { name: string };
export type FileItem = { name: string; path: string; type: "file" | "dir" };

export async function checkAuthStatus(): Promise<{ authenticated: boolean }> {
  return apiGet(`${apiURL}/auth/status`);
}

export async function getRepositories(): Promise<{ repositories: Repo[] }> {
  return apiGet(`${apiURL}/gitlab/repositories`);
}

export async function getBranches(repo_url: string): Promise<{ branches: Branch[] }> {
  return apiPost(`${apiURL}/gitlab/branches`, { repo_url });
}

export async function getFiles(repo_url: string, branch_name: string): Promise<{ files: FileItem[] }> {
  return apiPost(`${apiURL}/gitlab/files`, { repo_url, branch_name });
}

export async function loginRequest(): Promise<{ authorization_url: string }> {
  return apiGet(`${apiURL}/auth/gitlab/login`);
}

export async function logout(): Promise<any> {
  return apiPost(`${apiURL}/auth/logout`);
}

export default {
  checkAuthStatus,
  getRepositories,
  getBranches,
  getFiles,
  loginRequest,
  logout,
};
